module.exports = __webpack_public_path__ + "static/1278911675.d85a75ae.jpg";